import { Panel } from "./shared";

export const Pdf2ImgPanel = ({ imgFormat, onChange, activePicker }) => (
  <Panel>
    <div className="grid grid-cols-2 gap-1 p-1 bg-page border border-hairline rounded-lg" data-testid="img-format-picker">
      {["png", "jpg"].map((f) => (
        <button key={f} data-testid={`img-format-${f}`} onClick={() => onChange(f)}
          className={`py-2 min-h-[44px] rounded-full font-mono text-xs transition-colors duration-300 ${imgFormat === f ? activePicker : "text-fog hover:text-ink"}`}>
          {f}
        </button>
      ))}
    </div>
  </Panel>
);
